<template>
  <div>
    <div class="row">
      <div class="col-7 col-sm-9 form-group mb-0 pb-4">
        <label :for="field">{{ label }}</label>
        <p v-if="!editing" class="mb-0 lead" :class="{ 'text-muted': !value }">
          {{ value ? value : "Enter " + label }}
        </p>
        <input
          v-else
          v-model="value"
          :type="type"
          class="form-control"
          :class="{ 'is-invalid': errors }"
          :id="field"
          :placeholder="placeholder"
        />
      </div>
      <div class="col-5 col-sm-3 pb-4 d-flex flex-column justify-content-start">
        <button
          v-if="!editing"
          @click.prevent="editing = true"
          class="btn btn-primary"
          :disabled="locked"
        >
          {{ locked ? "Locked" : "Edit" }}
        </button>
        <div v-else class="d-flex">
          <button
            @click.prevent="
              editing = false;
              value = initialValue;
            "
            class="btn btn-secondary flex-grow-1 mr-1"
          >
            Cancel
          </button>
          <button
            @click.prevent="save"
            class="btn btn-primary flex-grow-1 ml-2"
            :disabled="saving"
          >
            {{ saving ? "Saving" : "Save" }}
          </button>
        </div>
      </div>
    </div>

    <div v-if="errors" class="row">
      <div class="col-9">
        <div class="invalid-feedback d-block">
          <ul class="errors">
            <li v-for="(error, index) in errors[field]" :key="index">
              <strong>{{ error }}</strong>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    model: {
      type: String,
      required: true,
    },
    locked: {
      type: Boolean,
      defaut: false,
    },
    id: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    field: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    initialValue: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      saving: false,
      editing: false,
      errors: null,

      value: this.initialValue,
    };
  },

  methods: {
    save() {
      if (this.locked) {
        this.saving = false;
        this.editing = false;
        return;
      }

      this.saving = true;

      const form = {};
      form[this.field] = this.value;

      this.$nextTick(() => {
        window.axios
          .put(`/${this.model}/${this.id}`, form)
          .then(() => {
            this.saving = false;
            this.editing = false;
          })
          .catch((error) => {
            this.saving = false;
            this.errors = error.response.data.errors;
            throw new Error(error);
          });
      });
    },
  },
};
</script>
